<div class="nrk-card">
  <div class="nrk-card-header">
    <span class="version"></span>
    <span class="user">
      <a href="mailto:{{activity?.owner?.username}}">{{activity?.owner?.name}}</a>&nbsp;@ {{activity?.business?.name}} ({{activity.location}})</span>
      <div class="date">
        <span>{{activity.date | date: 'yyyy-MM-dd'}}</span>
        <span *ngIf="activity.dateTo">&nbsp;to&nbsp;{{activity.dateTo | date: 'yyyy-MM-dd'}}</span>
      </div>
    </div>
  <div class="nrk-card-body" style="white-space:pre-wrap;">
    
    <div class="row" *ngIf="getImageUrl()!=null" >
      <div class="col-12"><img class="img-thumbnail" [src]="getImageUrl()"></div>
    </div>
    <h5>{{activity.title}}</h5>{{activity.purpose}}

  </div>
  <div class="nrk-card-footer">
    <div>
      <ng-container *ngIf="activity?.content?.type == ContentType.VisitReport
        || activity?.content?.type == ContentType.OnlineMeeting
        || activity?.content?.type == ContentType.TradeShowMeeting
        || activity?.content?.type == ContentType.OnSiteMeeting
        || activity?.content?.type == ContentType.ProjectSummary
      ">
        <a *ngIf="activity?.content?.type == ContentType.ProjectSummary; else noSr" [routerLink]="[]" (click)="downloadInternalUpdates()">PDF</a>
        <ng-template #noSr><a [routerLink]="[]" (click)="downloadVr()">PDF</a></ng-template>
      </ng-container>

      <label class="pull-right">
        <a [routerLink]="[]" (click)="show.emit(activity)" >{{ContentType[activity.content.type]}}</a>
      </label>
    </div>
  </div>
</div>

<ngx-internal-updates #internalUpdates></ngx-internal-updates>

